import {
  AirlineIcon as CoreAirlineIcon,
  type AirlineIconProps as CoreAirlineIconProps,
} from "@b2bportal/core-ui";
import clsx from "clsx";

import "./styles.scss";

export type IAirlineIconProps = CoreAirlineIconProps;

const AirlineIcon = ({
  size = "large",
  className,
  airlineCode,
  altText,
}: IAirlineIconProps) => {
  return (
    <CoreAirlineIcon
      className={clsx("airline-icon", className)}
      airlineCode={airlineCode}
      size={size}
      altText={altText}
    />
  );
};

export default AirlineIcon;
